import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    CmpsBadgeModule,
    CmpsButtonModule,
    CmpsIconModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';

import { CmpsLazyI18nModule } from '../../../i18n/i18n.module';
import { CmpsEventCentreDialogModule } from '../dialog';

import { EventCentreNavButtonComponent } from './event-centre-nav-button.component';
import { TranslationIdMap } from './event-centre-nav-button.i18n';

@NgModule({
    declarations: [EventCentreNavButtonComponent],
    imports: [
        CmpsBadgeModule,
        CmpsButtonModule,
        CmpsEventCentreDialogModule,
        CmpsIconModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsTooltipModule,
        CommonModule,
    ],
    exports: [EventCentreNavButtonComponent],
})
export class CmpsEventCentreNavButtonModule {}
